// apps/lk/src/lib/dashboard-cache.ts
// Клиентский кеш дашборда в браузере.
// TTL 5 минут: в течение этого времени НИ ОДНОГО запроса к серверу.
// После — один фоновый запрос на обновление.
// Инвалидация: ручная (invalidateDashboard()) после теста.

const CACHE_KEY = 'tb_dashboard_v1';
const TTL_MS = 5 * 60 * 1000; // 5 минут — полный запрет запросов

type CacheEntry = {
  data: any;
  ts: number;
  userId: string;
};

/** Возвращает кеш, если он свежий (< TTL). Иначе null. */
export function getCachedDashboard(userId: string): any | null {
  try {
    const raw = sessionStorage.getItem(CACHE_KEY);
    if (!raw) return null;
    const entry: CacheEntry = JSON.parse(raw);
    if (entry.userId !== userId) return null;
    if (Date.now() - entry.ts > TTL_MS) return null;
    return entry.data;
  } catch {
    return null;
  }
}

/** Возвращает кеш даже если устаревший — для мгновенного рендера, пока идёт запрос. */
export function getStaleDashboard(userId: string): any | null {
  try {
    const raw = sessionStorage.getItem(CACHE_KEY);
    if (!raw) return null;
    const entry: CacheEntry = JSON.parse(raw);
    if (entry.userId !== userId) return null;
    return entry.data;
  } catch {
    return null;
  }
}

/** Нужен ли фоновый запрос? true только если кеш устарел. */
export function needsRefresh(userId: string): boolean {
  try {
    const raw = sessionStorage.getItem(CACHE_KEY);
    if (!raw) return true;
    const entry: CacheEntry = JSON.parse(raw);
    if (entry.userId !== userId) return true;
    return Date.now() - entry.ts > TTL_MS;
  } catch {
    return true;
  }
}

export function setCachedDashboard(userId: string, data: any): void {
  try {
    const entry: CacheEntry = { data, ts: Date.now(), userId };
    sessionStorage.setItem(CACHE_KEY, JSON.stringify(entry));
  } catch {}
}

export function invalidateDashboard(): void {
  try {
    sessionStorage.removeItem(CACHE_KEY);
  } catch {}
}
